<template>
	<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
		<circle cx="6" cy="6" r="1.8" fill="currentColor"></circle>
		<circle cx="12" cy="6" r="1.8" fill="currentColor"></circle>
		<circle cx="18" cy="6" r="1.8" fill="currentColor"></circle>
		<circle cx="6" cy="12" r="1.8" fill="currentColor"></circle>
		<circle cx="12" cy="12" r="1.8" fill="currentColor"></circle>
		<circle cx="18" cy="12" r="1.8" fill="currentColor"></circle>
		<circle cx="6" cy="18" r="1.8" fill="currentColor"></circle>
		<circle cx="12" cy="18" r="1.8" fill="currentColor"></circle>
		<circle cx="18" cy="18" r="1.8" fill="currentColor"></circle>
	</svg>
</template>
